import * as React from "react";
import * as d3 from "d3/dist/d3"; // UNUSUAL IMPORT FOR TO MAKE IE11 WORK
var ReactFauxDOM = require("react-faux-dom");
var ReactDOM = require("react-dom");

let radius = 375;
let svgPie;

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

const pieColors = ["#92BC58", "#47B4BC", "#FABA59", "#0476BC"];

const pie = d3
  .pie()
  .sortValues(d => d.tag)
  .padAngle(0.025)
  .value(d => d.value);

const arc = d3
  .arc()
  .outerRadius(radius * 1.0)
  .innerRadius(radius * 0.75);

const outerArc = d3
  .arc()
  .innerRadius(radius * 0.5)
  .outerRadius(radius * 1);

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.id = ("chart" + "-" + Math.random()).replace(".", "");
    // console.log(this.id);

    // Create faux DOM element for pie chart
    this.div = new ReactFauxDOM.createElement("div", this.id);
    this.div.setAttribute("id", this.id);

    // Create SVG in dom
    svgPie = d3
      .select(this.div)
      .append("svg")
      // .data([data])
      .attr("width", 750)
      .attr("height", 750)
      .attr("viewBox", "0 0 750 750")
      .append("g")
      .attr("transform", `translate(${radius},${radius})`);

    // Add .segments class to segments in SVG
    svgPie.append("g").attr("class", "segments");

    //
    // ED should be able to append SVG paths for center here, but not sure if it's smart
    //
  }

  // DOM should not re-render; it stays put while D3 controls it
  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    update(
      [
        { label: "Tribe 1", value: 0 },
        { label: "Tribe 2", value: 0 },
        { label: "Tribe 3", value: 0 },
        { label: "Tribe 4", value: 0 }
      ],
      this.id
    ); // splash
    update(this.props.data, this.id); // init
  }

  componentWillReceiveProps(props) {
    update(props.data, this.id); // update
  }

  godamnJaff() {
    {
      return {
        __html:
          "<circle cx='375.07' cy='375.11' r='278.96' fill='#fff'/><text transform='translate(220.52 382.1)' font-size='35.57' fill='#404040' font-weight='700'><tspan letter-spacing='-0.06em'>Y</tspan><tspan x='16.72' y='0'>ou</tspan><tspan x='57.19' y='0' letter-spacing='-0.03em'>r</tspan><tspan x='69.03' y='0'> </tspan><tspan x='78.56' y='0' letter-spacing='0em'>t</tspan><tspan x='91.69' y='0'>ypolog</tspan><tspan x='201.41' y='0' letter-spacing='-0.03em'>y</tspan><tspan x='219.44' y='0' xml:space='preserve'> map </tspan></text><circle cx='468.97' cy='267.84' r='71.33' fill='#91bc58'/><circle cx='281.16' cy='482.38' r='71.33' fill='#faba5a'/><circle cx='468.97' cy='482.38' r='71.33' fill='#47B4BC'/><path d='M464.47,295a41.73,41.73,0,0,1-10.38-1.37,57.87,57.87,0,0,1-7.52-2.73l-2.73-1.36c-.45,0-.95.36-1.5,1.09-.36.45-1,1.27-1.78,2.46a19,19,0,0,1-2.45,3.55,4.14,4.14,0,0,1-3,1.77,5.17,5.17,0,0,1-4.1-1.91,4.77,4.77,0,0,1-1.36-3.28,5.56,5.56,0,0,1,1.77-3.68,29.55,29.55,0,0,1,3.55-3.15,15.7,15.7,0,0,0,2.33-2,3,3,0,0,0,1.09-1.78l-.55-1c-.27-.82-.54-1.73-.82-2.73a22.45,22.45,0,0,1-.41-4.37,25,25,0,0,1,7.11-17.48,37.8,37.8,0,0,1,16.52-10.25,32.19,32.19,0,0,1,6.56-1.23q2.59-.13,8.06-.27,7.92-.27,11.33-.68c3.92-.55,6.65-1.59,8.2-3.14l1.37-1.23a12.09,12.09,0,0,1,2.45-2.19,7.56,7.56,0,0,1,3.62-.82q2.13,0,3.76,3.42a27.54,27.54,0,0,1,2.19,7.1,38.4,38.4,0,0,1,.54,5.87,37.9,37.9,0,0,1-5.87,20.9q-6.29,9.71-18.85,15.85A42.92,42.92,0,0,1,464.47,295ZM464,266.75q8.53-4,20.15-3.15a1.71,1.71,0,0,0,1.5-.47,2.49,2.49,0,0,0,.82-1.51,1.84,1.84,0,0,0-.48-1.57,2.54,2.54,0,0,0-1.57-.82q-12.57-.94-22.2,3.55t-16.86,14.76a1.87,1.87,0,0,0-.41,1.57,2.09,2.09,0,0,0,.88,1.43,2.12,2.12,0,0,0,1.64.41,2.07,2.07,0,0,0,1.44-1Q455.46,270.71,464,266.75Z' fill='#fff'/><path d='M270.64,499.32a2.61,2.61,0,0,1-1.09-1.51,38.52,38.52,0,0,0-3.56-7,57.45,57.45,0,0,0-3.41-4.65,34.93,34.93,0,0,1-4-5.73,23.37,23.37,0,0,1-1.5-9,24,24,0,1,1,48.07,0,23.37,23.37,0,0,1-1.5,9,34.93,34.93,0,0,1-4,5.73,57.45,57.45,0,0,0-3.41,4.65,37.86,37.86,0,0,0-3.55,7,2.67,2.67,0,0,1-1.1,1.51,3.37,3.37,0,0,1-1.91.54H272.55A3.37,3.37,0,0,1,270.64,499.32Zm2.8-35.58a10.52,10.52,0,0,1,7.72-3.21,2.14,2.14,0,0,0,1.57-.62,2.33,2.33,0,0,0,0-3.14,2.14,2.14,0,0,0-1.57-.62,15.3,15.3,0,0,0-15.3,15.3,2.12,2.12,0,0,0,.61,1.57,2.19,2.19,0,0,0,3.76-1.57A10.5,10.5,0,0,1,273.44,463.74Zm18.64,46a3.09,3.09,0,0,1-.61,1.91,3.79,3.79,0,0,1-1.57,1.23v1.23a3.28,3.28,0,0,1-3.28,3.28H275.69a3.28,3.28,0,0,1-3.28-3.28v-1.23a3.79,3.79,0,0,1-1.57-1.23,3.09,3.09,0,0,1-.61-1.91v-3.83a1.59,1.59,0,0,1,.48-1.16,1.57,1.57,0,0,1,1.16-.48h18.57a1.55,1.55,0,0,1,1.16.48,1.59,1.59,0,0,1,.48,1.16Z' fill='#fff'/><circle cx='281.16' cy='267.84' r='71.33' fill='#0376bb'/><path d='M268.86,273.3a3.28,3.28,0,0,1,2.32,5.6l-5.73,5.74a23.16,23.16,0,0,0,15.71,6.15,22.91,22.91,0,0,0,22.26-17.35,1.59,1.59,0,0,1,.55-.89,1.62,1.62,0,0,1,1.09-.34h7.78a1.64,1.64,0,0,1,1.64,1.91,33.32,33.32,0,0,1-6.28,14.07,34.54,34.54,0,0,1-11.81,9.9,32.73,32.73,0,0,1-15.23,3.62,33.32,33.32,0,0,1-23.36-9.42l-4.92,4.91a3.28,3.28,0,0,1-5.6-2.32v-18.3a3.28,3.28,0,0,1,3.28-3.28Zm20.7-26.84a23.1,23.1,0,0,0-8.4-1.57,22.91,22.91,0,0,0-22.27,17.35,1.67,1.67,0,0,1-.54.89,1.72,1.72,0,0,1-1.1.34h-7.78a1.56,1.56,0,0,1-1.3-.62,1.53,1.53,0,0,1-.34-1.29,33.32,33.32,0,0,1,6.28-14.07,34.62,34.62,0,0,1,11.82-9.91A32.82,32.82,0,0,1,281.16,234a33.27,33.27,0,0,1,23.35,9.43l4.92-4.92a3.28,3.28,0,0,1,5.6,2.32V259.1a3.26,3.26,0,0,1-3.28,3.27h-18.3a3.26,3.26,0,0,1-3.28-3.27,3.18,3.18,0,0,1,1-2.33l5.73-5.73A23.33,23.33,0,0,0,289.56,246.46Z' fill='#fff'/><path d='M484.27,447.41a6.54,6.54,0,0,1,6.56,6.56v56.82a6.54,6.54,0,0,1-6.56,6.56H453.68a6.54,6.54,0,0,1-6.56-6.56V454a6.54,6.54,0,0,1,6.56-6.56ZM469,513a4.42,4.42,0,1,0-3.07-1.29A4.23,4.23,0,0,0,469,513Z' fill='#fff'/>"
      };
    }
  }

  render() {
    // console.log(this.props);
    return (
      <div className="graph">
        {this.div.toReact()}

        <svg
          width="750"
          height="750"
          viewBox="0 0 750 750"
          dangerouslySetInnerHTML={this.godamnJaff()}
        />
      </div>
    );
  }
}

// Convert [25,25,25,25] to object array with tribe labels and percentages that add up to 100
// const parseData = arr => {
//   const total = weightings => weightings.reduce((acc, v) => acc + v);
//   let data = arr.map((d, i) => {
//     return {
//       label: "Tribe " + i,
//       value: total(arr) != 0 ? d / total(arr) * 100 : 0 // percentages
//     };
//   });
//   return data;
// };

// const makeData = () => {
//   let a = Math.random() * 33;
//   let b = Math.random() * 33;
//   let c = Math.random() * 33;
//   let d = 100 - (a + b + c);
//   let data = [
//     { label: "Tribe 1", value: a }
//     { label: "Tribe 2", value: b },
//     { label: "Tribe 3", value: c },
//     { label: "Tribe 4", value: d }
//   ];
//   return data;
//   // var sortedData = data.sort(function(a, b) {
//   //   return d3.ascending(a.label, b.label);
//   // });
// };

// https://jsfiddle.net/rshaker/rbmgacep/
const update = (data, id) => {
  // IE11 squashed slice animation
  var duration = isIE11 ? 100 : 1000;

  // Re-select the DOM element as it.. gets lost
  svgPie = d3.select(`#${id} svg`);
  // console.log(`#${id} svg`);

  var oldData = svgPie
    .select(".segments")
    .selectAll("path")
    .data()
    .map(function(d) {
      return d.data;
    });

  if (oldData.length == 0) oldData = data;

  // var was = mergeWithFirstEqualZero(data, oldData);
  // var is = mergeWithFirstEqualZero(oldData, data);
  var was = oldData;
  var is = data;

  var slice = svgPie
    .select(".segments")
    .selectAll("path")
    .data(pie(was), d => d.data.label);

  slice
    .enter()
    .insert("path")
    .attr("class", "slice")
    .style("fill", function(d) {
      return pieColors[d.index];
      // return col;
    })
    .each(function(d) {
      this._current = d;
    });

  slice = svgPie
    .select(".segments")
    .selectAll("path")
    .data(pie(is), d => d.data.label);

  slice
    .transition()
    .duration(duration)
    .attrTween("d", function(d) {
      var interpolate = d3.interpolate(this._current, d);
      var _this = this;
      return function(t) {
        _this._current = interpolate(t);
        return arc(_this._current);
      };
    });

  slice = svgPie
    .select(".segments")
    .selectAll("path")
    .data(pie(data), d => d.data.label);

  slice
    .exit()
    .transition()
    .delay(duration)
    .duration(0)
    .remove();
};

// function mergeWithFirstEqualZero(first, second) {
//   var secondSet = d3.set();

//   second.forEach(function(d) {
//     secondSet.add(d.label);
//   });

//   var onlyFirst = first
//     .filter(function(d) {
//       return !secondSet.has(d.label);
//     })
//     .map(function(d) {
//       return { label: d.label, value: 0 };
//     });

//   var sortedMerge = d3.merge([second, onlyFirst]).sort(function(a, b) {
//     return d3.ascending(a.label, b.label);
//   });

//   return sortedMerge;
// }



// WEBPACK FOOTER //
// ./src/components/PieChart.js